import React, { useEffect, useRef, useState } from 'react'
import { motion, useAnimationControls } from 'framer-motion'
import { GlobeTeammateCard } from '../globe/GlobeTeammateCard'
import { UserResponse } from '../../types/users/user-response'
import { TeammatesWithOnlineUserCountResponse } from '../../types/creator/response/teammates-pagination-response'
import { GameCategories } from '../../common/enums/game-categories'
import Image from 'next/image'
import { useRecoilState } from 'recoil'
import { selectedGameState } from '../../common/atoms/atoms'
import { GameTeammatesV2 } from '../../api/creators/getGamingTeammates'

type Props = {
  gameTeammates: GameTeammatesV2
}

export default function EarthAnimation({ gameTeammates }: Props) {
  const controlsOCreatorCard = useAnimationControls()
  const controlsOCreatorCard2 = useAnimationControls()
  const [teammate1, setTeammate1] = useState<UserResponse>()
  const [teammate2, setTeammate2] = useState<UserResponse>()
  const teammatesRef = useRef<TeammatesWithOnlineUserCountResponse | null>(null)
  const [game] = useRecoilState(selectedGameState)
  const timeout = useRef<any | null>(null)

  function startNormalController1() {
    controlsOCreatorCard.start({
      x: [-100, -250],
      opacity: [0, 1, 0],
      transition: {
        delay: 1,
        duration: 4.5,
        ease: 'linear',
      },
    })
  }

  function startNormalController2() {
    controlsOCreatorCard2.start({
      x: [-100, -210],
      opacity: [0, 1, 0],
      transition: {
        delay: 3,
        duration: 4.5,
        ease: 'linear',
      },
    })
  }

  function initAnimations() {
    let teammates: TeammatesWithOnlineUserCountResponse

    switch (game?.key) {
      case GameCategories.valorant:
        teammates = gameTeammates.valorantCompetitiveTeammates
        break
      case GameCategories.fortnite:
        teammates = gameTeammates.fortniteCompetitiveTeammates
        break
      case GameCategories.tft:
        teammates = gameTeammates.tftCompetitiveTeammates
        break
      default:
        teammates = gameTeammates.leagueCompetitiveTeammates
        break
    }

    teammatesRef.current = teammates

    if (teammates) {
      controlsOCreatorCard.set({ opacity: 0 })
      controlsOCreatorCard2.set({ opacity: 0 })

      randomTeammates(teammates)
      randomTeammates2(teammates)

      startNormalController1()
      startNormalController2()
    }
  }

  function randomTeammates(teammates: TeammatesWithOnlineUserCountResponse) {
    try {
      const randomIndex =
        teammates?.teammates[
          Math.floor(Math.random() * (teammates?.teammates?.length ?? 0))
        ]
      setTeammate1(randomIndex)
    } catch (e) {}
  }

  function randomTeammates2(teammates: TeammatesWithOnlineUserCountResponse) {
    try {
      const randomIndex =
        teammates?.teammates[
          Math.floor(Math.random() * (teammates?.teammates?.length ?? 0))
        ]
      setTeammate2(randomIndex)
    } catch (e) {}
  }

  useEffect(() => {
    timeout.current = setTimeout(() => {
      if (game?.active) {
        try {
          controlsOCreatorCard.stop()
          controlsOCreatorCard2.stop()
        } catch (e) {}
        initAnimations()
      }
    }, 1000)

    return () => {
      try {
        clearTimeout(timeout.current)
      } catch (e) {}
    }
  }, [])

  return (
    <div className={'relative hidden w-[730px] justify-center md:flex'}>
      <motion.div
        className={
          'absolute left-1/2 top-[21rem] z-20 -translate-x-1/2 -translate-y-1/2 opacity-0'
        }
        onAnimationComplete={() => {
          if (teammatesRef.current) randomTeammates(teammatesRef.current)
          startNormalController1()
        }}
        animate={controlsOCreatorCard}
      >
        <GlobeTeammateCard teammate={teammate1} game={game} />
      </motion.div>

      <motion.div
        className={
          'absolute left-1/2 top-[10rem] z-20 -translate-x-1/2 -translate-y-1/2 opacity-0'
        }
        onAnimationComplete={() => {
          if (teammatesRef.current) randomTeammates2(teammatesRef.current)
          startNormalController2()
        }}
        id='div2'
        animate={controlsOCreatorCard2}
      >
        <GlobeTeammateCard teammate={teammate2} game={game} />
      </motion.div>

      <div
        className={
          'earth relative flex w-full flex-col items-center justify-center'
        }
      >
        <Image
          src={
            'https://d1qrjcmi5hciyv.cloudfront.net/image-assets/globe-white.png'
          }
          className={'object-contain object-top'}
          width={555}
          height={533}
          priority={true}
          alt={'EarthPlacement'}
        />
      </div>
    </div>
  )
}
